(function () {

    "use strict";

    function viewerService($resource, URL) {

        var self = this;

        self.associatedViewer = $resource(URL.URL + '/api/viewer/associated/:extension', { extension: '@_extension' });
        self.associatedPublicViewer = $resource(URL.URL + '/public/office/associated/:extension', { extension: '@_extension' });

    }

    viewerService.$inject = ["$resource", "URL"];

    angular.module("sphforms.main").service("solpheo.viewerService", viewerService);

})();